import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyTicketsState } from '../reducers';

export const getTicketsState = createSelector(getDragonflyTicketsState, (state) => state?.tickets);

export const getSideNav = createSelector(getTicketsState, (state) => state?.sideNav);

export const getPanelExpanded = createSelector(getTicketsState, (state) => state?.panelExpanded);

export const getCanCreateTicket = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('tickets.action.createticket') ? true : false,
);

export const getCanViewDetails = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('ticket.data.view.details') ? true : false,
);

export const getTicketID = createSelector(getTicketsState, (state) => state?.ticketId);

export const getTicketSeverityValues = createSelector(getTicketsState, (state) => state?.ticketSeverityValues);

export const getTicketSeverity = createSelector(getTicketsState, (state) => state?.ticketSeverity);

export const getLoyaltySchemaValues = createSelector(getTicketsState, (state) => state?.loyaltySchemaValues);

export const getLoyaltySchema = createSelector(getTicketsState, (state) => state?.loyaltySchema);

export const getStatusValues = createSelector(getTicketsState, (state) => state?.ticketStatusValues);

export const getStatus = createSelector(getTicketsState, (state) => state?.ticketStatus);

export const getCountryValues = createSelector(getTicketsState, (state) => state?.countryValues);

export const getCountry = createSelector(getTicketsState, (state) => state?.country);

export const getCategoryValues = createSelector(getTicketsState, (state) => state?.ticketCategoryValues);

export const getCategory = createSelector(getTicketsState, (state) => state?.ticketCategory);

export const getAssigneeValues = createSelector(getTicketsState, (state) => state?.ticketAssigneeValues);

export const getAssignee = createSelector(getTicketsState, (state) => state?.ticketAssignee);

export const getBody = createSelector(getTicketsState, (state) => state?.body);

export const getSubject = createSelector(getTicketsState, (state) => state?.subject);
